interface CustomReport {
    view: {
        overview: {
            header: {
                title: string;
                subTitle: string;
            };
            table: {
                noReports: string;
                description: string;
                title: string;
                button: {
                    use: string;
                    api: string;
                };
            };
        };
        detailPage: {
            title: string;
            button: {
                back: string;
                edit: string;
            };
            tab: {
                general: {
                    tabTitle: string;
                    content: {
                        title: string;
                        apiName: string;
                        targetCollectionName: string;
                        description: string;
                        producer: string;
                        icon: string;
                    };
                };
                execution: {
                    tabTitle: string;
                    title: string;
                    description: string;
                    content: {
                        button: {
                            execute: string;
                            download: string;
                        };
                        resultSet: {
                            title: string;
                            noContent: string;
                            button: {
                                exportResult: {
                                    main: string;
                                    currentPage: string;
                                    entireResultSet: {
                                        text: string;
                                        popUp: string;
                                    }
                                };
                                exportType: {
                                    popup: string;
                                };
                            };
                        };
                        parameter: {
                            mandatory: string;
                        }
                    };
                    toast: {
                        error: {
                            98: string;
                            99: string;
                            100: string;
                            101: string;
                            102: string;
                            103: string;
                            104: string;
                            105: string;
                            106: string;
                            107: string;
                            108: string;
                            109: string;
                            110: string;
                            111: string;
                            112: string;
                            113: string;
                        };
                    };
                };
            };
        };
    };
    configuration: {
        unsavedChanges: string;
        editor: {
            title: {
                create: string;
                edit: string;
            };
            header: {
                button: {
                    back: string;
                    save: string;
                };
            };
            tabTitle: {
                general: string;
                jsonEditor: string;
                resultSchemaEditor: string;
                template: string;
            };
            generalTab: {
                icon: string;
                apiName: string;
                collectionName: string;
                indexes: string;
                listOfIndexes: string;
                title: {
                    english: string;
                    german: string;
                };
                description: {
                    english: string;
                    german: string;
                };
                button: {
                    addIndex: string;
                    editIndex: string;
                    deleteIndex: string;
                    pickIcon: string;
                };
                indexForm: {
                    formTitle: string;
                    indexName: string;
                    fieldName: string;
                    apply: string;
                    update: string;
                    abort: string;
                };
            };
            jsonEditorTab: {
                parameter: {
                    key: string;
                    button: {
                        delete: string;
                    }
                    name: {
                        title: string;
                        placeholder: string;
                    };
                    description: {
                        title: string;
                        placeholder: string;
                    };
                    type: {
                        title: string;
                        values: {
                            text: string;
                            number: string;
                            date: string;
                            boolean: string;
                        };
                    };
                    dateValue: {
                        dateAsText: {
                            title: string;
                            dateTimeZone: string;
                        };
                        popupText: {
                            withSetUnit: string;
                            withoutUnit: string;
                            boundText: string;
                            time: {
                                future: string;
                                past: string;
                            };
                            bound: {
                                start: string;
                                end: string;
                            };
                            units: {
                                singular: {
                                    day: string;
                                    week: string;
                                    month: string;
                                };
                                plural: {
                                    day: string;
                                    week: string;
                                    month: string;
                                };
                            };
                        };
                        preset: string;
                        presetPlaceholder: string;
                        unit: {
                            title: string;
                            none: string;
                            day: string;
                            week: string;
                            month: string;
                        };
                        offset: string;
                        bound: {
                            title: string;
                            none: string;
                            start: string;
                            end: string;
                        };
                        dateFormat: {
                            title: string;
                            popupText: string;
                        };
                        date: string;
                        time: string;

                    };
                    boolValue: {
                        trueValue: string;
                        falseValue: string;
                    };
                    defaultValue: {
                        title: string;
                        placeholder: string;
                        popupText: string;
                    };
                    mandatory: {
                        title: string;
                        popupText: string;
                    };
                    nullable: {
                        textTitle: string;
                        defaultTitle: string;
                        popupText: string;
                    };
                    customizable: {
                        title: string;
                        popupText: string;
                    };
                    values: {
                        title: string;
                        popupText: string;
                        placeholder: string;
                    };
                };
                jsonEditor: {
                    header: {
                        description: string;
                        documentationAggregationPipeline: string;
                        documentationTooltip: string;
                    };
                    body: {
                        parameter: {
                            title: string;
                        }
                    };
                    stage: {
                        deletePopUp: string;
                    }
                };
                header: {
                    stage: {
                        buttonNew: string;
                    };
                    parameter: {
                        buttonNew: string;
                    }
                }
            };
            templateTab: {
                header: {
                    title: string;
                    description: {
                        paraOne: string;
                        paraTwo: string;
                    };
                    outputFormat: string;
                }
            };
            saving: {
                error: {
                    emptyPipeline: string;
                    apiNameMissing: string;
                    collectionNameMissing: string;
                    producerMissing: string;
                    duplicateParameterIdentifier;
                };
            };
        };
        overview: {
            header: {
                title: string;
                subTitle: string;
                button: {
                    new: string;
                    import: string;
                    upload: string;
                };
            };
            button: {
                new: string;
            };
            table: {
                headerCell: {
                    apiName: string;
                    collectionName: string;
                    title: string;
                };
                button: {
                    api: string;
                    edit: string;
                    download: string;
                };
            };
            deleteModal: {
                header: string;
                textWithTitle: string;
                textWithoutTitle: string;
                confirmation: string;
                button: {
                    cancel: string;
                    delete: string;
                };
            };
        };
        apiModal: {
            swaggerFile: string;
            button: {
                close: string;
            };
        };
    };
};

const en: CustomReport = {
    view: {
        overview: {
            header: {
                title: "Custom reports",
                subTitle: "Overview and application of all user-defined reports"
            },
            table: {
                title: "Title",
                description: "Description",
                button: {
                    api: "API",
                    use: "Use"
                },
                noReports: "There are no available custom reports."
            }
        },
        detailPage: {
            title: "Custom Report \"{{display_name}}\"",
            button: {
                back: "Back",
                edit: "Edit"
            },
            tab: {
                general: {
                    tabTitle: "General",
                    content: {
                        title: "Title",
                        apiName: "API Name",
                        targetCollectionName: "Target Mongo Collection",
                        description: "Description",
                        producer: "Report Producer",
                        icon: "Icon",
                    }
                },
                execution: {
                    tabTitle: "Execution",
                    title: "Execution",
                    description: "Query a pipeline by settings it's parameters and requesting an answer.",
                    content: {
                        button: {
                            execute: "Execute Query",
                            download: "Download Query (??)"
                        },
                        resultSet: {
                            title: "Result set",
                            noContent: "Report has not yet been inquired.",
                            button: {
                                exportResult: {
                                    main: "Export result",
                                    currentPage: "Current page",
                                    entireResultSet: {
                                        text: "Entire result",
                                        popUp: "This process could take several minutes."
                                    }
                                },
                                exportType: {
                                    popup: "Export file as {{type}}"
                                }
                            }
                        },
                        parameter: {
                            mandatory: "Mandatory"
                        }
                    },
                    toast: {
                        error: {
                            98: "There was an unknown error while processing the report pipeline with the given parameters.",
                            99: "The collection \"{{collectionName}}\" defined inside the chosen custom report doesn't exists.",
                            100: "Report with apiName \"{{apiName}}\" not found.",
                            101: "The value of a parameter must not contain either of the following characters: {{values}}",
                            102: "Missing mandatory parameters: {{parameterNames}}",
                            103: "The value of the parameter \"{{parameterName}}\" must not be null.",
                            104: "The value of the parameter \"{{parameterName}}\" cannot be customized.",
                            105: "The value of the parameter \"{{parameterName}}\" must be either of the following: {{values}}",
                            106: "Invalid date format received.",
                            107: "No date value configuration was defined to calculate an appropriate date string.",
                            108: "No value has been assigned to the \"{{parameterName}}\" parameter and no default value is predefined.",
                            109: "The value of the parameter \"{{parameterName}}\" was not correctly set. It must be of the following type: {{parameterType}}",
                            110: "Unexpected date format.",
                            111: "The date for parameter \"{{parameterName}}\" is not in the correct format \"{{format}}\"",
                            112: "The value for parameter \"{{parameterName}}\" is not a number.",
                            113: "The given parameter type \"{{parameterType}}\" for parameter \"{{parameterName}}\" is not supported."
                        }
                    }
                }
            }
        }
    },
    configuration: {
        unsavedChanges: "Unsaved changes.",
        editor: {
            title: {
                create: "Create Report",
                edit: "Edit Report \"{{display_name}}\""
            },
            header: {
                button: {
                    back: "Back",
                    save: "Save"
                }
            },
            saving: {
                error: {
                    apiNameMissing: "API Name is missing.",
                    collectionNameMissing: "The target collection name is missing.",
                    emptyPipeline: "The report pipeline is empty.",
                    producerMissing: "The producer of the report is not given.",
                    duplicateParameterIdentifier: "Duplicate parameter keys are assigned."
                }
            },
            generalTab: {
                apiName: "API Name",
                collectionName: "Collection Name",
                icon: "Icon",
                indexes: "Indexes",
                listOfIndexes: "List of indexes for this report",
                title: {
                    english: "Title (english)",
                    german: "Title (german)"
                },
                description: {
                    english: "Description (english)",
                    german: "Description (german)"
                },
                button: {
                    addIndex: "Add",
                    editIndex: "Edit",
                    deleteIndex: "Delete",
                    pickIcon: "Choose"
                },
                indexForm: {
                    formTitle: "Add new index for current report",
                    indexName: "Name of Index",
                    fieldName: "Name of Field",
                    apply: "Apply",
                    update: "Update",
                    abort: "Abort"
                }
            },
            tabTitle: {
                general: "General",
                jsonEditor: "Report pipeline editor",
                resultSchemaEditor: "Result schema editor",
                template: "Template"
            },

            jsonEditorTab: {
                parameter: {
                    key: "Key",
                    button: {
                        delete: "Delete Parameter"
                    },
                    type: {
                        title: "Type",
                        values: {
                            date: "Date",
                            text: "Text",
                            number: "Number",
                            boolean: "Boolean"
                        }
                    },
                    boolValue: {
                        trueValue: "true",
                        falseValue: "false"
                    },
                    dateValue: {
                        dateAsText: {
                            title: "Date as Text",
                            dateTimeZone: "Date Time Zone",
                        },
                        popupText: {
                            withSetUnit: "The given date is adjusted by {{positiveOffset}} {{unitPlural}} in the {{futureOrPast}}",
                            withoutUnit: "The date is not adjusted.",
                            boundText: "and bound to the {{startOrEnd}} of the calculated {{unit}}.",
                            time: {
                                future: "future",
                                past: "past"
                            },
                            bound: {
                                start: "start",
                                end: "end"
                            },
                            units: {
                                singular: {
                                    day: "day",
                                    week: "week",
                                    month: "month"
                                },
                                plural: {
                                    day: "day(s)",
                                    week: "week(s)",
                                    month: "month(s)"
                                }
                            }
                        },
                        offset: "Offset",
                        dateFormat: {
                            title: "Date Format",
                            popupText: "The specified date format is used only when the specified report is used by a direct API call."
                        },
                        bound: {
                            title: "Bound",
                            none: "-",
                            start: "Start",
                            end: "End"
                        },
                        preset: "Preset",
                        presetPlaceholder: "Select...",
                        unit: {
                            title: "Unit",
                            none: "-",
                            day: "Day(s)",
                            month: "Month(s)",
                            week: "Week(s)"
                        },
                        date: "Date",
                        time: "Time"
                    },
                    description: {
                        placeholder: "Placeholder...",
                        title: "Description"
                    },
                    name: {
                        placeholder: "Placeholder...",
                        title: "Parameter Name"
                    },
                    defaultValue: {
                        title: "Default Value",
                        popupText: "The default value is chosen if no other value was specified.",
                        placeholder: "Value..."
                    },
                    mandatory: {
                        title: "Mandatory",
                        popupText: "States if the parameter must be specified in the query."
                    },
                    nullable: {
                        textTitle: "Nullable or blankable",
                        defaultTitle: "Nullable",
                        popupText: "States if the parameter can be set to 'null'."
                    },
                    customizable: {
                        title: "Customizable Input",
                        popupText: "States if the parameter can be a custom rather than a predefined value."
                    },
                    values: {
                        title: "Predefined Values",
                        popupText: "List of selectable predefined values.",
                        placeholder: "Custom value..."
                    }
                },
                jsonEditor: {
                    header: {
                        description: "Configure a custom report pipeline by defining MongoDB stages with Parameters in the form of $PARAMETER$",
                        documentationAggregationPipeline: "Documentation aggregation pipeline",
                        documentationTooltip: "Link to official MongoDB documentation"
                    },
                    body: {
                        parameter: {
                            title: "Parameters"
                        }
                    },
                    stage: {
                        deletePopUp: "Delete Stage"
                    }
                },
                header: {
                    stage: {
                        buttonNew: "Stage",
                    },
                    parameter: {
                        buttonNew: "Parameter",
                    }
                }
            },
            templateTab: {
                header: {
                    title: "Reporting Templates",
                    description: {
                        paraOne: "Transfer the output of an executed report into a designated format by defining type-specific templates.",
                        paraTwo: "You have the option of creating a corresponding template for each available output format."
                    },
                    outputFormat: "Output format",
                }
            }
        },
        overview: {
            header: {
                title: "Overview",
                subTitle: "Overview of the custom reports",
                button: {
                    new: "New",
                    import: "Import custom report",
                    upload: "Import"
                }
            },
            button: {
                new: "New Report",
            },
            table: {
                headerCell: {
                    apiName: "API Name",
                    collectionName: "Collection Name",
                    title: "Title (english)",
                },
                button: {
                    api: "API",
                    edit: "Edit",
                    download: "Export"
                }
            },
            deleteModal: {
                header: "Delete Report {{name}}",
                textWithTitle: "Do you wish to delete the report {{title}} with the API name {{apiName}}?",
                textWithoutTitle: "Do you wish to delete the report with the API name {{apiName}}?",
                confirmation: "To delete this report enter the API Name \"{{apiName}}\".",
                button: {
                    cancel: "Cancel",
                    delete: "Delete",
                },
            }
        },
        apiModal: {
            swaggerFile: "Swagger file",
            button: {
                close: "Close"
            }
        }
    }
}

const de: CustomReport = {
    view: {
        overview: {
            header: {
                title: "Benutzerdefinierte Reports",
                subTitle: "Übersicht und Anwendung aller benutzerdefinierten Reports"
            },

            table: {
                title: "Titel",
                description: "Beschreibung",
                button: {
                    api: "API",
                    use: "Verwenden"
                },
                noReports: "Es sind keine benutzerdefinierten Reports verfügbar."
            }
        },
        detailPage: {
            title: "Benutzerdefinierter Report \"{{display_name}}\"",
            button: {
                back: "Zurück",
                edit: "Editieren"
            },
            tab: {
                general: {
                    tabTitle: "Generell",
                    content: {
                        title: "Titel",
                        apiName: "API-Name",
                        targetCollectionName: "Ziel-Mongo-Collection",
                        description: "Beschreibung",
                        producer: "Report Ersteller",
                        icon: "Icon",
                    }
                },
                execution: {
                    tabTitle: "Ausführung",
                    title: "Ausführung",
                    description: "Sende eine Anfrage durch Belegung der Parameter.",
                    content: {
                        button: {
                            execute: "Ausführen",
                            download: "Abfrage herunterladen (??)"
                        },
                        resultSet: {
                            title: "Ergebnismenge",
                            noContent: "Der Report wurde noch nicht angefordert.",
                            button: {
                                exportResult: {
                                    main: "Antwort exportieren",
                                    currentPage: "Aktuelle Seite",
                                    entireResultSet: {
                                        popUp: "Dieser Vorgang kann mehrere Minuten dauern.",
                                        text: "Gesamte Ergebnismenge"
                                    }
                                },
                                exportType: {
                                    popup: "Exportiere Datei in {{type}}"
                                }
                            }
                        },
                        parameter: {
                            mandatory: "Verpflichtend"
                        }
                    },
                    toast: {
                        error: {
                            98: "Bei der Verarbeitung der Berichtspipeline mit den angegebenen Parametern ist ein unbekannter Fehler aufgetreten.",
                            99: "Die im ausgewählten benutzerdefinierten Bericht definierte Collection \"{{collectionName}}\" existiert nicht.",
                            100: "Report mit apiName \"{{apiName}}\" nicht gefunden.",
                            101: "Der Wert eines Parameters darf keines der folgenden Zeichen enthalten: {{values}}",
                            102: "Fehlende obligatorische Parameter: {{parameterNames}}",
                            103: "Der Wert des Parameters \"{{parameterName}}\" darf nicht Null sein.",
                            104: "Der Wert des Parameters \"{{parameterName}}\" ist nicht frei setzbar.",
                            105: "Der Wert des Parameters \"{{parameterName}}\" muss einer der folgenden sein: {{values}}",
                            106: "Ungültiges Datumsformat erhalten.",
                            107: "Es ist keine Datumswertkonfiguration vorhanden, um eine geeignete Datumszeichenfolge zu berechnen.",
                            108: "Es wurde kein Wert für den Parameter \"{{parameterName}}\" vergeben und es ist kein Standardwert vordefiniert.",
                            109: "Der Wert des Parameters \"{{parameterName}}\" wurde nicht korrekt gesetzt. Er muss vom folgenden Typ sein: {{parameterType}}",
                            110: "Unerwartetes Datumsformat.",
                            111: "Das Datum für den Parameter \"{{parameterName}}\" hat nicht das richtige Format \"{{format}}\".",
                            112: "Der Wert für den Parameter \"{{parameterName}}\" ist keine Zahl.",
                            113: "Der Wert des Parameters \"{{parameterName}}\" wurde nicht korrekt gesetzt. Er muss vom folgenden Typ sein: {{parameterType}}"
                        }
                    }
                }
            }
        }
    },
    configuration: {
        unsavedChanges: "Ungespeicherte Änderungen.",
        editor: {
            title: {
                create: "Report erstellen",
                edit: "Report \"{{display_name}}\" editieren"
            },
            tabTitle: {
                general: "Generell",
                jsonEditor: "Report Pipeline Editor",
                resultSchemaEditor: "Ausgabeschema Editor",
                template: "Template"
            },
            header: {
                button: {
                    back: "Zurück",
                    save: "Speichern"
                }
            },
            saving: {
                error: {
                    apiNameMissing: "API-Name nicht definiert.",
                    collectionNameMissing: "Der adressierte Collection-Name ist nicht definiert.",
                    emptyPipeline: "Die Report-Pipeline ist leer.",
                    producerMissing: "Der Produzent des Reports ist nicht vergeben.",
                    duplicateParameterIdentifier: "Es sind doppelte Parameterschlüssel vergeben."
                }
            },
            generalTab: {
                apiName: "API-Name",
                collectionName: "Collection-Name",
                icon: "Icon",
                indexes: "Indizes",
                listOfIndexes: "Liste der Indizes für diesen Report",
                title: {
                    english: "Titel (englisch)",
                    german: "Titel (deutsch)"
                },
                description: {
                    english: "Beschreibung (englisch)",
                    german: "Beschreibung (deutsch)"
                },
                button: {
                    addIndex: "Hinzufügen",
                    editIndex: "Bearbeiten",
                    deleteIndex: "Löschen",
                    pickIcon: "Wählen"
                },
                indexForm: {
                    formTitle: "Neuen Index für aktuellen Report hinzufügen",
                    indexName: "Name des Index",
                    fieldName: "Name des Feldes",
                    apply: "Übernehmen",
                    update: "Aktualisieren",
                    abort: "Zurücksetzen"
                }
            },
            jsonEditorTab: {
                parameter: {
                    key: "Schlüssel",
                    button: {
                        delete: "Parameter entfernen"
                    },
                    type: {
                        title: "Typ",
                        values: {
                            date: "Datum",
                            text: "Text",
                            number: "Zahl",
                            boolean: "Boolean"
                        }
                    },
                    boolValue: {
                        trueValue: "true",
                        falseValue: "false"
                    },
                    dateValue: {
                        dateAsText: {
                            title: "Datum als Text",
                            dateTimeZone: "Datum Zeitzone",
                        },
                        popupText: {
                            withSetUnit: "Das angegebene Datum wird um {{positiveOffset}} {{unitPlural}} in die {{futureOrPast}} verändert",
                            withoutUnit: "Das angegebene Datum wird nicht verändert.",
                            boundText: "und an {{startOrEnd}} {{unit}} gesetzt.",
                            time: {
                                future: "Zukunft",
                                past: "Vergangenheit"
                            },
                            bound: {
                                start: "den Anfang",
                                end: "das Ende"
                            },
                            units: {
                                singular: {
                                    day: "des kalkulierten Tages",
                                    week: "der kalkulierten Woche",
                                    month: "des kalkulierten Monats"
                                },
                                plural: {
                                    day: "Tag(e)",
                                    week: "Woche(n)",
                                    month: "Monat(e)"
                                }
                            }
                        },
                        offset: "Versatz",
                        dateFormat: {
                            title: "Datumsformat",
                            popupText: "Das angegebene Datumsformat wird nur verwendet, wenn der angegebene Bericht durch einen direkten API-Aufruf verwendet wird."
                        },
                        bound: {
                            title: "Angrenzung",
                            none: "-",
                            start: "Start",
                            end: "Ende"
                        },
                        preset: "Voreinstellung",
                        presetPlaceholder: "Auswählen...",
                        unit: {
                            title: "Einheit",
                            none: "-",
                            day: "Tag(e)",
                            month: "Monat(e)",
                            week: "Woche(n)"
                        },
                        date: "Datum",
                        time: "Uhrzeit"
                    },
                    description: {
                        placeholder: "Platzhalter...",
                        title: "Beschreibung"
                    },
                    name: {
                        placeholder: "Platzhalter...",
                        title: "Parametername"
                    },
                    defaultValue: {
                        title: "Standardwert",
                        popupText: "Der Standardwert wird gewählt, falls kein anderer Wert angegeben wurde.",
                        placeholder: "Wert..."
                    },
                    mandatory: {
                        title: "Verpflichtend",
                        popupText: "Gibt an, ob der Parameter in der Abfrage angegeben werden muss."
                    },
                    nullable: {
                        textTitle: "Null- oder Leerbar",
                        defaultTitle: "Nullbar",
                        popupText: "Gibt an, ob der Parameter auf 'null' gesetzt werden kann."
                    },
                    customizable: {
                        title: "Freisetzbarer Wert",
                        popupText: "Gibt an, ob der Parameter ein benutzerdefinierter Wert und nicht ein vordefinierter Wert sein kann."
                    },
                    values: {
                        title: "Vordefinierte Werte",
                        popupText: "Liste von verfügbaren vorspezifizierten Werten.",
                        placeholder: "Wert..."
                    }
                },
                jsonEditor: {
                    header: {
                        description: "Konfigurieren Sie eine benutzerdefinierte Report-Pipeline durch Definition von MongoDB-Stages mit Parametern der Form $PARAMETER$",
                        documentationAggregationPipeline: "Dokumentation Aggregation Pipeline",
                        documentationTooltip: "Link zur offiziellen MongoDB Dokumentation"
                    },
                    body: {
                        parameter: {
                            title: "Parameter"
                        }
                    },
                    stage: {
                        deletePopUp: "Stage entfernen"
                    }
                },
                header: {
                    stage: {
                        buttonNew: "Stage",
                    },
                    parameter: {
                        buttonNew: "Parameter",
                    }
                }
            },
            templateTab: {
                header: {
                    title: "Reporting Templates",
                    description: {
                        paraOne: "Überführen Sie die Ausgabe eines durchgeführten Reports in ein vorgesehenes Format durch Definition typenspezifischer Templates.",
                        paraTwo: "Sie haben die Möglichkeit je verfügbaren Ausgabeformat ein entsprechendes Template anzulegen."
                    },
                    outputFormat: "Ausgabeformat",
                }
            }
        },
        overview: {
            header: {
                title: "Übersicht",
                subTitle: "Übersicht der benutzerdefinierten Reports",
                button: {
                    new: "Neu",
                    import: "Importieren den benutzerdefinierten Bericht",
                    upload: "Importieren"
                }
            },
            button: {
                new: "Neuer Report",
            },
            table: {
                headerCell: {
                    apiName: "API-Name",
                    collectionName: "Collection-Name",
                    title: "Titel (deutsch)"
                },
                button: {
                    api: "API",
                    edit: "Editieren",
                    download: "Exportieren"
                }
            },
            deleteModal: {
                header: "Report {{name}} löschen",
                textWithTitle: "Möchten Sie den Report {{title}} mit dem API-Namen {{apiName}} löschen?",
                textWithoutTitle: "Möchten Sie den Report mit dem API-Namen {{apiName}} löschen?",
                confirmation: "Geben Sie den API-Namen \"{{apiName}}\" an, um den Report zu löschen.",
                button: {
                    cancel: "Abbrechen",
                    delete: "Löschen",
                },
            }
        },
        apiModal: {
            swaggerFile: "Swagger-Datei",
            button: {
                close: "Schließen"
            }
        }
    }
}

export default {
    en, de
};